<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import { cloneDeep } from "lodash";
import createNumberMask from "text-mask-addons/dist/createNumberMask";
import MaskedInput from "vue-text-mask";
import Stocks from "@/components/modals/stock-debit.vue";
import Office from "@/components/modals/delivery-unit.vue";
import PrintOptions from "@/components/modals/print-options.vue";
import UploadPopover from "@/components/widgets/upload-popover.vue";
import RawData from "@/components/widgets/raw-data.vue";

export default {
  page: {
    title: "Stock Request"
  },
  components: {
    Layout,
    PageHeader,
    MaskedInput,
    Stocks,
    Office,
    PrintOptions,
    UploadPopover,
    RawData
  },
  data() {
    return {
      title: "Stock Request",
      submitted: false,
      items: [
        {
          text: "Dashboards",
          href: "/"
        },
        {
          text: "Stock Request",
          active: true
        }
      ],
      currencyMask: createNumberMask({
        prefix: "",
        allowDecimal: true
      }),
      quantityMask: createNumberMask({
        prefix: "",
        includeThousandsSeparator: false
      }),
      tableData: [],
      modalTitle: "",
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: "",
      filterOn: [],
      sortBy: "id",
      sortDesc: false,
      pendingFields: [
        {
          key: "referenceNo",
          sortable: false,
          tdClass: "align-middle"
        },
        {
          key: "description",
          sortable: false,
          tdClass: "align-middle",
          thStyle: { width: "400px" }
        },
        {
          key: "quantity",
          sortable: false,
          tdClass: "align-middle",
          thStyle: { width: "300px" }
        },
        {
          key: "actions",
          sortable: false,
          tdClass: "align-middle",
          thStyle: { width: "70px" }
        }
      ],
      postedFields: [
        {
          key: "referenceNo",
          sortable: false,
          tdClass: "align-middle"
        },
        {
          key: "description",
          sortable: false,
          tdClass: "align-middle",
          thStyle: { width: "400px" }
        },
        {
          key: "quantity",
          sortable: false,
          tdClass: "align-middle",
          thStyle: { width: "400px" }
        }
      ],
      form: {
        campusId: null,
        deliveryUnitId: null,
        status: "DRAFT",
        requisitionNumber: "",
        requisitionItems: []
      },
      transaction: {
        stockItemId: null,
        stockItem: "",
        quantity: "",
        maxQuantity: null,
        note: "",
        iarItemId: 0,
        endUserId: "",
        propertyLocationId: 0
      },
      debitReference: "",
      tableBusy: false,
      cycle: this.$store.state.data.cycle,
      campusId: this.$store.state.data.selectedCampus.id,
      isAdmin: this.$store.state.decrypt.isAdmin(),
      token: this.$store.state.decrypt.getToken(),
      uploadOptions: {
        type: "Transaction",
        placement: "lefttop",
        folder: "Stocks"
      },
      tabIndex: 0
    };
  },
  computed: {
    filtered() {
      let data = this.tableData;
      if (this.filter.trim() != "" && this.filter) {
        data = data.filter((item) => {
          if (
            item.referenceNumber
              .toUpperCase()
              .includes(this.filter.toUpperCase())
          ) {
            return item.referenceNumber
              .toUpperCase()
              .includes(this.filter.toUpperCase());
          } else if (
            item.deliveryUnit &&
            item.deliveryUnit.name
              .toUpperCase()
              .includes(this.filter.toUpperCase())
          ) {
            return item.deliveryUnit.name
              .toUpperCase()
              .includes(this.filter.toUpperCase());
          } else if (
            item.description.toUpperCase().includes(this.filter.toUpperCase())
          ) {
            return item.description
              .toUpperCase()
              .includes(this.filter.toUpperCase());
          } else if (
            item.credit.toString().includes(this.filter.toUpperCase())
          ) {
            return item.credit.toString().includes(this.filter.toUpperCase());
          } else if (
            item.debit.toString().includes(this.filter.toUpperCase())
          ) {
            return item.debit.toString().includes(this.filter.toUpperCase());
          }
        });
      }
      return data;
    },
    rows() {
      if (this.filter.trim() != "" && this.filter) {
        return this.filtered.length;
      } else {
        return this.tableData.length;
      }
    }
  },
  created() {
    this.changeCampus(this.$store.state.data.selectedCampus);
  },
  methods: {
    changeCampus(data) {
      this.campusId = data.id;
      this.cycle = this.$store.state.data.cycle;
      if (this.tabIndex == 0) this.getPendingTransactions();
      else this.getPostedTransactions();
    },
    changeDU(data) {
      this.campusId = data.campusId;
      this.cycle = this.$store.state.data.cycle;
      if (this.tabIndex == 0) this.getPendingTransactions();
      else this.getPostedTransactions();
    },
    changeCycle(data) {
      this.campusId = data.campusId;
      this.cycle = data;
      if (this.tabIndex == 0) this.getPendingTransactions();
      else this.getPostedTransactions();
    },
    getPendingTransactions() {
      this.tableBusy = true;
      this.$store
        .dispatch("stock/GetPendingStockTransaction", this.campusId)
        .then((res) => {
          res.data.forEach((item) => {
            item.stockFiles = [];
            item.viewFile = false;
            item.addDocu = false;
            item.attachmentLoading = false;
          });
          this.tableData = res.data;
          this.tableBusy = false;
        })
        .catch(() => {
          this.tableBusy = false;
          this.showToast("Something went wrong - Getting requests!", "error");
        });
    },
    getPostedTransactions() {
      this.tableBusy = true;
      this.$store
        .dispatch("stock/GetPostedStockTransaction", this.campusId)
        .then((res) => {
          res.data.forEach((item) => {
            item.stockFiles = [];
            item.viewFile = false;
            item.addDocu = false;
            item.attachmentLoading = false;
          });
          this.tableData = res.data;
          this.tableBusy = false;
        })
        .catch(() => {
          this.tableBusy = false;
          this.showToast("Something went wrong - Getting requests!", "error");
        });
    },
    createRequisition() {
      this.onReset();
      this.form.campusId = this.campusId;
      this.form.deliveryUnitId = this.deliveryUnitId;
      this.modalTitle = "Create Request";
      this.$bvModal.show("modal-requisition");
    },
    onAddTransaction() {
      this.submitted = true;
      if (this.checkForm([this.transaction])) {
        return;
      }
      let transaction = cloneDeep(this.transaction);
      this.form.requisitionItems.push(transaction);
      this.$bvModal.hide("modal-transaction");
      this.$bvModal.show("modal-requisition");
      this.submitted = false;
    },
    addTransaction() {
      this.submitted = false;
      this.transaction = {
        stockItemId: null,
        stockItem: "",
        quantity: "",
        maxQuantity: null,
        note: "",
        iarItemId: 0,
        endUserId: "",
        propertyLocationId: 0
      };
      this.$bvModal.hide("modal-requisition");
      this.$bvModal.show("modal-transaction");
    },
    removeTransaction(index) {
      this.form.requisitionItems.splice(index, 1);
    },
    closeTransaction() {
      this.$bvModal.hide("modal-transaction");
      this.$bvModal.show("modal-requisition");
    },
    onPostTransaction(props) {
      this.submitted = true;
      if (this.checkForm()) {
        return;
      } else {
        this.$swal({
          title: "Are you sure?",
          text: "You are about to approve this transaction.",
          icon: "question",
          showCancelButton: true,
          confirmButtonColor: "#34c38f",
          cancelButtonColor: "#5c636a",
          confirmButtonText: "Yes, approve it!",
          allowOutsideClick: false
        }).then((result) => {
          if (result.isConfirmed) {
            var data = cloneDeep(this.form);
            data.credit = this.getExactAmt(data.credit);
            this.$store
              .dispatch("stock/UpdateStockTransaction", data)
              .then((res) => {
                if (res.data.error) {
                  return this.showToast(res.data.errorMessage, "error");
                }
                this.$store
                  .dispatch("stock/ApproveStockTransaction", data.id)
                  .then(() => {
                    var index = this.tableData.findIndex(
                      (item) => item.id == data.id
                    );
                    this.tableData.splice(index, 1);
                    this.$bvModal.hide("modal-transaction");
                    this.showToast("Successfully Approved", "success");
                  });
              })
              .catch((err) => {
                this.showToast("Cannot be Approved!", "error");
              });
          }
        });
        this.submitted = false;
      }
    },
    async postTransaction(props) {
      this.onReset();
      this.form = cloneDeep(props);
      this.form.requestedCredit = cloneDeep(this.form.credit);
      this.form.credit = this.form.credit.toString();
      this.modalTitle = "Approve Transaction";
      this.$bvModal.show("modal-transaction");
    },
    deleteTransaction(props) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#dc3545",
        cancelButtonColor: "#5c636a",
        confirmButtonText: "Yes, delete it!",
        allowOutsideClick: false
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store
            .dispatch("stock/DeleteStockTransaction", props.id)
            .then((res) => {
              var transIndex = this.tableData.findIndex(
                (item) => item.id == props.id
              );
              this.tableData.splice(transIndex, 1);
              this.showToast("Successfully deleted", "success");
            })
            .catch((err) => {
              this.showToast("Cannot be deleted!", "error");
            });
        }
      });
    },
    async runningBalance(data) {
      let balance = 0;
      if (data) {
        for (let i = 0; i < data.length; i++) {
          if (data[i].status == "POSTED") {
            balance += data[i].debit - data[i].credit;
          }
        }
      }
      return balance;
    },
    checkForm() {
      if (
        this.form.credit === "" ||
        this.form.credit === null ||
        this.form.deliveryUnitId === "" ||
        this.form.deliveryUnitId === null ||
        this.form.stockItemTransactionParentId === "" ||
        this.form.stockItemTransactionParentId === null
      ) {
        return true;
      } else return false;
    },
    onReset() {
      this.form = {
        campusId: null,
        deliveryUnitId: null,
        status: "DRAFT",
        requisitionNumber: "",
        requisitionItems: []
      };
      this.transaction = {
        stockItemId: null,
        stockItem: "",
        quantity: "",
        maxQuantity: null,
        note: "",
        iarItemId: 0,
        endUserId: "",
        propertyLocationId: 0
      };
      this.submitted = false;
    },
    getStocks() {
      this.$refs.stocks.getData(true);
      this.$bvModal.show("stocks-modal");
    },
    async dropStocks(data) {
      await this.$store
        .dispatch("stock/GetStockTransactions", data.id)
        .then((res) => {
          data.transactions = res.data;
        });
      this.transaction.maxQuantity = this.runningBalance(data.transactions);
      this.transaction.stockItemId = data.id;
      this.transaction.stockItem = data.name;
    },
    getDebit() {
      this.$refs.stockdebit.getData(this.form.stockItem);
      this.$bvModal.show("stock-debit-modal");
    },
    dropDebit(data) {
      this.debitReference = `PO No. ${data.referenceNumber}`;
      this.form.stockItemTransactionParentId = data.id;
      this.form.unitCost = data.unitCost;
      this.form.maxCredit = data.available;
    },
    getOffice() {
      this.$refs.office.getSingleData();
      this.$bvModal.show("office-modal");
    },
    dropOffice(data) {
      this.form.deliveryUnitId = data.id;
      this.form.deliveryUnit = data.name;
    },
    checkCredit() {
      if (parseFloat(this.form.credit) > parseFloat(this.form.maxCredit))
        this.form.credit = this.form.maxCredit.toString();
    },
    getAttachments(row) {
      row.viewFile = true;
      row.stockFiles = [];
      row.attachmentLoading = true;
      this.$store
        .dispatch("filemanager/GetFiles", {
          id: row.id,
          type: this.uploadOptions.type
        })
        .then((res) => {
          row.attachmentLoading = false;
          row.stockFiles = res.data;
        })
        .catch(() => {
          row.attachmentLoading = false;
          this.showToast("Something went wrong! - getting documents", "error");
        });
    },
    openDocument(x) {
      this.readFile(x.id);
    },
    removeFile(id, transactionId) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#dc3545",
        cancelButtonColor: "#5c636a",
        confirmButtonText: "Yes, remove it!",
        allowOutsideClick: false
      }).then((result) => {
        if (result.value) {
          this.$store
            .dispatch("filemanager/DeleteFile", id)
            .then((res) => {
              if (res.data.error) {
                return this.showToast(res.data.errorMessage, "error");
              }
              let transactionIndex = this.tableData.findIndex(
                (item) => item.id == transactionId
              );
              let fileIndex = this.tableData[
                transactionIndex
              ].stockFiles.findIndex((item) => item.id == id);
              this.tableData[transactionIndex].stockFiles.splice(fileIndex, 1);
              this.showToast("Successfully removed!", "success");
            })
            .catch(() => {
              this.showToast("Cannot be deleted!", "error");
            });
        }
      });
    },
    uploadedFiles() {}
  }
};
</script>

<template>
  <Layout
    @changeCampus="changeCampus"
    @changeDU="changeDU"
    @changeCycle="changeCycle"
  >
    <PageHeader :title="title" :items="items" />
    <!-- Create/Update Transaction -->
    <b-modal
      id="modal-requisition"
      :title="modalTitle"
      size="lg"
      title-class="font-18"
      hide-footer
      no-close-on-backdrop
    >
      <form
        @submit.prevent="onCreateRequisition"
        class="needs-validation"
        ref="fcForm"
      >
        <div>
          <div class="d-flex align-items-center justify-content-between">
            <div><h5 class="mt-2 mb-0">Stock Item</h5></div>
            <div>
              <button
                type="button"
                @click="addTransaction()"
                class="btn btn-sm btn-primary d-flex align-items-center ms-1"
              >
                <i class="bx bx-plus fs-6 me-1"></i>Add Stock
              </button>
            </div>
          </div>

          <hr />
          <div v-if="form.requisitionItems.length == 0">
            <div class="p-3 d-flex align-items-center justify-content-center">
              <span class="text-warning m-0">Add an item for transfer.</span>
            </div>
            <hr />
          </div>
          <div v-else>
            <div
              v-for="(item, index) in form.requisitionItems"
              :key="index"
              class="mb-3"
            >
              <div
                class="d-flex align-items-center justify-content-between px-2"
              >
                <div>
                  {{ item.stockItem }}
                </div>
                <div class="d-flex align-items-center justify-content-between">
                  <div>
                    <masked-input
                      id="credit"
                      type="text"
                      v-model="item.quantity"
                      placeholder="Enter Quantity..."
                      class="form-control form-control-sm"
                      :class="{
                        'is-invalid':
                          submitted &&
                          (item.quantity == null || item.quantity == '')
                      }"
                      autocomplete="off"
                      :mask="quantityMask"
                      @input="checkCredit(item)"
                    ></masked-input>
                  </div>
                  <div class="ms-5">
                    <i
                      @click="removeTransaction(index)"
                      class="cursor-pointer bx bx-trash text-danger font-size-18"
                    ></i>
                  </div>
                </div>
              </div>
              <hr />
            </div>
          </div>
        </div>

        <div class="d-flex flex-row-reverse">
          <button class="btn btn-primary mt-3" type="submit">
            {{ form.id > 0 ? "Update" : "Create" }}
          </button>
        </div>
      </form>
    </b-modal>
    <!-- Add Transaction -->
    <b-modal
      id="modal-transaction"
      title="Add Stock"
      size="md"
      title-class="font-18"
      hide-footer
      no-close-on-backdrop
      @close="closeTransaction"
    >
      <form
        @submit.prevent="onAddTransaction"
        class="needs-validation"
        ref="fcForm"
      >
        <div class="mb-3">
          <label for="stockId">Stock </label>
          <b-input-group>
            <template #append>
              <b-button @click="getStocks" variant="outline-info"
                ><i class="mdi mdi-clipboard-text-search-outline"></i
              ></b-button>
            </template>
            <input
              autocomplete="off"
              type="text"
              disabled
              placeholder="Search Stock..."
              class="form-control"
              :class="{
                'is-invalid': submitted && transaction.stockItemId == null
              }"
              v-model="transaction.stockItem"
            />
          </b-input-group>
          <div
            v-if="submitted && transaction.stockItemId == null"
            class="invalid-feedback"
          >
            <span>This value is required.</span>
          </div>
        </div>
        <div class="mb-3">
          <label for="credit"
            ><div>Quantity</div>
            <small>Max Quantity: {{ transaction.maxQuantity }}</small></label
          >
          <masked-input
            v-if="transaction.maxQuantity && transaction.maxQuantity > 0"
            id="credit"
            type="text"
            v-model="transaction.quantity"
            placeholder="Enter Quantity..."
            class="form-control"
            :class="{
              'is-invalid':
                submitted &&
                (transaction.quantity == null || transaction.quantity == '')
            }"
            autocomplete="off"
            :mask="quantityMask"
            @input="checkCredit(transaction)"
          ></masked-input>
          <input
            v-else
            id="credit"
            type="text"
            v-model="transaction.quantity"
            placeholder="Enter Quantity..."
            class="form-control"
            :class="{
              'is-invalid':
                submitted &&
                (transaction.quantity == null || transaction.quantity == '')
            }"
            disabled
            autocomplete="off"
          />
          <div
            v-if="
              submitted &&
                (transaction.quantity == null || transaction.quantity == '')
            "
            class="invalid-feedback"
          >
            <span>This value is required.</span>
          </div>
        </div>

        <div class="d-flex flex-row-reverse mb-3">
          <button class="btn btn-primary mt-3" type="submit">
            Add
          </button>
        </div>
      </form>
    </b-modal>
    <!-- Approve Transaction -->
    <!-- <b-modal
      id="modal-transaction"
      :title="modalTitle"
      size="md"
      title-class="font-18"
      hide-footer
      no-close-on-backdrop
    >
      <form
        @submit.prevent="onPostTransaction"
        class="needs-validation"
        ref="fcForm"
      >
        <div>
          <div class="mb-3">
            <label for="stockItemTransactionParentId">Debit </label>
            <b-input-group>
              <template #append>
                <b-button @click="getDebit" variant="outline-info"
                  ><i class="mdi mdi-clipboard-text-search-outline"></i
                ></b-button>
              </template>
              <input
                autocomplete="off"
                type="text"
                disabled
                placeholder="Search Debit..."
                class="form-control"
                :class="{
                  'is-invalid':
                    submitted && form.stockItemTransactionParentId == null
                }"
                v-model="debitReference"
              />
            </b-input-group>
            <div
              v-if="submitted && form.stockItemTransactionParentId == null"
              class="invalid-feedback"
            >
              <span>This value is required.</span>
            </div>
          </div>
          <div class="mb-3">
            <label for="credit">
              <div>Credit</div>
              <div class="font-size-10">
                Requested Quantity: {{ form.requestedCredit }}
              </div>
              <div class="font-size-10">Max Credit: {{ form.maxCredit }}</div>
            </label>
            <masked-input
              v-if="form.maxCredit > 0"
              id="credit"
              type="text"
              v-model="form.credit"
              placeholder="Enter Credit..."
              class="form-control"
              :class="{
                'is-invalid':
                  submitted && (form.credit == null || form.credit == '')
              }"
              autocomplete="off"
              :mask="quantityMask"
              @input="checkCredit()"
            ></masked-input>
            <input
              v-else
              id="credit"
              type="text"
              v-model="form.credit"
              placeholder="Enter Quantity..."
              class="form-control"
              :class="{
                'is-invalid':
                  submitted && (form.credit == null || form.credit == '')
              }"
              disabled
              autocomplete="off"
            />
            <div
              v-if="submitted && (form.credit == null || form.credit == '')"
              class="invalid-feedback"
            >
              <span>This value is required.</span>
            </div>
          </div>
          <div v-if="!form.id" class="mb-3">
            <label for="office">Office </label>
            <b-input-group>
              <template #append>
                <b-button @click="getOffice()" variant="outline-info"
                  ><i class="mdi mdi-clipboard-text-search-outline"></i
                ></b-button>
              </template>
              <input
                autocomplete="off"
                type="text"
                disabled
                placeholder="Search Office..."
                class="form-control"
                :class="{
                  'is-invalid':
                    submitted &&
                    (form.deliveryUnitId == null || form.deliveryUnitId == '')
                }"
                v-model="form.deliveryUnit"
              />
            </b-input-group>
            <div
              v-if="
                submitted &&
                  (form.deliveryUnitId == null || form.deliveryUnitId == '')
              "
              class="invalid-feedback"
            >
              <span>This value is required.</span>
            </div>
          </div>
        </div>
        <div class="mb-3">
          <label for="description">Description </label>
          <textarea
            id="description"
            rows="6"
            v-model="form.description"
            placeholder="Enter Stock Description..."
            class="form-control"
            autocomplete="off"
          ></textarea>
        </div>

        <div class="d-flex flex-row-reverse mb-3">
          <button class="btn btn-primary mt-3" type="submit">
            Post
          </button>
        </div>
      </form>
    </b-modal> -->
    <!-- Main -->
    <div v-if="tabIndex == 0" class="d-flex float-end pt-2">
      <button
        type="button"
        @click="createRequisition()"
        class="btn btn-sm btn-primary d-flex align-items-center"
      >
        <i class="bx bx-plus fs-6 me-1"></i>Create Request
      </button>
    </div>
    <b-tabs
      content-class="pt-3 pb-3 text-muted"
      v-model="tabIndex"
      nav-class="nav-tabs-custom"
    >
      <!-- Pending -->
      <b-tab
        @click="
          getPendingTransactions();
          perPage = 10;
          currentPage = 1;
        "
      >
        <template v-slot:title>
          <span class="d-inline-block d-sm-none">
            <i class="mdi mdi-clock-time-four-outline"></i>
          </span>
          <span class="d-none d-sm-inline-block">Pending</span>
        </template>
        <div
          v-if="tabIndex == 0"
          class="card border-4 border-top border-start-0 border-end-0 border-primary"
        >
          <div class="card-body">
            <div class="col-12">
              <div class="row mb-1">
                <div class="col-md-6">
                  <div class="d-flex align-items-center h-100">
                    <h5 class="mb-0 mt-2">List of Pending Requests</h5>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="d-flex float-end">
                    <div
                      id="tickets-table_filter"
                      class="dataTables_filter me-1"
                    >
                      <label class="d-inline-flex align-items-center">
                        <b-form-input
                          autocomplete="off"
                          v-model="filter"
                          type="search"
                          placeholder="Search Transaction..."
                          class="form-control"
                        ></b-form-input>
                      </label>
                    </div>
                    <div id="tickets-table_length" class="dataTables_length">
                      <label class="d-inline-flex align-items-center mb-0">
                        <b-form-select
                          class="form-select"
                          v-model="perPage"
                          size="sm"
                          :options="pageOptions"
                        >
                        </b-form-select>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="custom-table-responsive mb-0 mt-2">
                <b-table
                  class="propertyTable transactionTable datatables target-table"
                  :items="filtered"
                  :fields="pendingFields"
                  responsive="sm"
                  :per-page="perPage"
                  :current-page="currentPage"
                  sort-by="id"
                  :sort-desc="true"
                  :busy="tableBusy"
                  show-empty
                  bordered
                >
                  <template #empty>
                    <b-card-header>
                      <div class="text-center">
                        <div v-if="filter != ''">
                          <i class="fas fa-exclamation-triangle me-2"></i>There
                          are no requests matching your request
                        </div>
                        <div v-else>
                          <i class="fas fa-exclamation-triangle me-2"></i>No
                          requests available
                        </div>
                      </div>
                    </b-card-header>
                  </template>
                  <template #table-busy>
                    <b-card-header>
                      <div
                        class="d-flex justify-content-center align-items-center"
                      >
                        <div class="preloader-component me-2">
                          <div class="status">
                            <div class="spinner-chase w-20px h-20px">
                              <div class="chase-dot"></div>
                              <div class="chase-dot"></div>
                              <div class="chase-dot"></div>
                              <div class="chase-dot"></div>
                              <div class="chase-dot"></div>
                              <div class="chase-dot"></div>
                            </div>
                          </div>
                        </div>
                        <strong>Loading...</strong>
                      </div>
                    </b-card-header>
                  </template>
                  <template #head(referenceNo)>
                    <div class="pb-4 text-center"><b>Transaction</b></div>
                  </template>
                  <template #cell(referenceNo)="row">
                    <div class="position-relative ms-1">
                      <RawData
                        :data="row.item"
                        v-if="$store.state.decrypt.isAdmin()"
                      />
                    </div>
                    <div class="p-3">
                      <small>{{
                        row.item.debit > 0
                          ? `PO No. ${row.item.referenceNumber}`
                          : `RIS No. ${row.item.referenceNumber}`
                      }}</small>
                      <div class="text-white" v-if="row.item.debit > 0">
                        {{ row.item.debit }} {{ row.item.stockItem.name }} added
                        to supply.
                      </div>
                      <div class="text-white" v-if="row.item.credit > 0">
                        {{ row.item.credit }}
                        {{ row.item.stockItem.name }} transferred to
                        {{ row.item.deliveryUnit.name }}.
                      </div>
                      <div>
                        <span class="me-1">Attachments:</span>
                        <a
                          href="javascript:void(0);"
                          @click="getAttachments(x)"
                          :id="`pending-viewFiles-${row.item.id}`"
                          >[Show attachments]</a
                        >
                        <b-popover
                          :target="`pending-viewFiles-${row.item.id}`"
                          triggers="click"
                          placement="right"
                          :show.sync="row.item.viewFile"
                          custom-class="popover-supplier"
                        >
                          <template v-slot:title>
                            <div
                              class="d-flex align-items-center justify-content-between"
                            >
                              <small>Attachments</small>
                              <span
                                class="bx bx-x font-size-14 cursor-pointer"
                                @click="row.item.viewFile = false"
                              ></span>
                            </div>
                          </template>
                          <table
                            class="table table-bordered"
                            v-if="
                              !row.item.attachmentLoading &&
                                row.item.stockFiles.length > 0
                            "
                          >
                            <thead>
                              <tr>
                                <th>File Description</th>
                                <th style="width: 30px"></th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr
                                v-for="attachments in row.item.stockFiles"
                                :key="attachments.id"
                              >
                                <td
                                  @click="openDocument(y)"
                                  class="hoverable-link cursor-pointer"
                                >
                                  <div>
                                    {{ attachments.description }}
                                  </div>
                                  <small>{{
                                    formatDateWithTime(
                                      new Date(attachments.dateTimeUploaded)
                                    )
                                  }}</small>
                                </td>
                                <td>
                                  <i
                                    v-if="
                                      isAdmin ||
                                        attachments.applicationUserId ==
                                          token.ApplicationUserId
                                    "
                                    @click="
                                      removeFile(attachments.id, row.item.id)
                                    "
                                    class="cursor-pointer bx bx-trash text-danger"
                                  ></i>
                                  <i v-else class="bx bx-trash text-muted"></i>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                          <div
                            class="text-center"
                            v-if="
                              !row.item.attachmentLoading &&
                                row.item.stockFiles.length == 0
                            "
                          >
                            No data found
                          </div>
                          <div
                            v-if="row.item.attachmentLoading"
                            class="text-center"
                          >
                            <b-spinner
                              variant="primary"
                              label="Loading..."
                            ></b-spinner>
                          </div>
                        </b-popover>
                      </div>
                      <div class="mt-1">
                        <button
                          :id="`pending-document${row.item.id}`"
                          type="button"
                          class="btn btn-sm btn-outline-success"
                          @click="row.item.addDocu = true"
                        >
                          <i class="bx bx-plus"></i>Add Attachments
                        </button>
                        <upload-popover
                          :option="uploadOptions"
                          :sourceId="row.item.id"
                          @uploaded="uploadedFiles"
                          :showPV="row.item.addDocu"
                          @closePopover="row.item.addDocu = false"
                          :dzId="`dropzone-pending${row.item.id}`"
                          :pvId="`pending-document${row.item.id}`"
                        ></upload-popover>
                      </div>
                    </div>
                  </template>
                  <template #head(description)>
                    <div class="pb-4 text-center"><b>Description</b></div>
                  </template>
                  <template #cell(description)="row">
                    <div class="p-3">
                      {{ row.item.description }}
                    </div>
                  </template>
                  <template #head(quantity)>
                    <div class="p-2 border-bottom text-center">
                      <b>Quantity</b>
                    </div>
                    <div class="p-0">
                      <div class="row m-0">
                        <div class="p-2 col-6 border-end text-center">
                          <b>Debit</b>
                        </div>
                        <div class="p-2 col-6 text-center">
                          <b>Credit</b>
                        </div>
                      </div>
                    </div>
                  </template>
                  <template #cell(quantity)="row">
                    <div class="row m-0">
                      <div
                        class="col-6 border-end d-flex align-items-center justify-content-center"
                        :class="{ 'text-success': row.item.debit }"
                      >
                        {{ row.item.debit > 0 ? row.item.debit : "-" }}
                      </div>
                      <div
                        class="col-6 d-flex align-items-center justify-content-center"
                        :class="{ 'text-danger': row.item.credit }"
                      >
                        {{ row.item.credit > 0 ? `- ${row.item.credit}` : "-" }}
                      </div>
                    </div>
                  </template>
                  <template #head(actions)>
                    <div class="pb-4 text-center"><b>Actions</b></div>
                  </template>
                  <template #cell(actions)="row">
                    <div class="text-center">
                      <i
                        class="fas fa-ellipsis-v cursor-pointer ps-2 pe-2"
                        :id="`transactions-pending-popover-${row.item.id}`"
                        tabindex="0"
                      ></i>
                      <b-popover
                        :target="`transactions-pending-popover-${row.item.id}`"
                        triggers="click blur"
                        placement="leftbottom"
                        variant="secondary"
                        custom-class="p-0"
                      >
                        <b-list-group class="w-100 fit">
                          <b-list-group-item
                            button
                            action
                            class="d-flex align-items-center text-success"
                            @click="postTransaction(row.item)"
                            ><i class="bx bx-check font-size-18 me-1"></i
                            >Approve</b-list-group-item
                          >
                          <!-- <b-list-group-item
                            button
                            action
                            class="d-flex align-items-center text-info"
                            @click="updateTransaction(row.item)"
                            ><i class="mdi mdi-update font-size-18 me-1"></i
                            >Update</b-list-group-item
                          > -->
                          <b-list-group-item
                            button
                            action
                            class="d-flex align-items-center text-danger"
                            @click="deleteTransaction(row.item)"
                            ><i class="mdi mdi-trash-can font-size-18 me-1"></i
                            >Delete</b-list-group-item
                          >
                        </b-list-group>
                      </b-popover>
                    </div>
                  </template>
                </b-table>
              </div>
              <div class="row">
                <div v-if="rows > 0" class="col">
                  Showing
                  {{ (currentPage - 1) * perPage + 1 }}
                  -
                  {{
                    rows > (currentPage - 1) * perPage + perPage
                      ? (currentPage - 1) * perPage + perPage
                      : rows
                  }}
                  of {{ rows }}
                </div>
                <div class="col">
                  <div
                    class="dataTables_paginate paging_simple_numbers float-end"
                  >
                    <ul
                      class="pagination pagination-rounded mb-0"
                      style="z-index: -1"
                    >
                      <!-- pagination -->
                      <b-pagination
                        v-model="currentPage"
                        :total-rows="rows"
                        :per-page="perPage"
                      ></b-pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-tab>
      <!-- Approved -->
      <b-tab
        @click="
          getPostedTransactions();
          perPage = 10;
          currentPage = 1;
        "
      >
        <template v-slot:title>
          <span class="d-inline-block d-sm-none">
            <i class="mdi mdi-check-circle-outline"></i>
          </span>
          <span class="d-none d-sm-inline-block">Approved</span>
        </template>
        <div
          v-if="tabIndex == 1"
          class="card border-4 border-top border-start-0 border-end-0 border-primary"
        >
          <div class="card-body">
            <div class="col-12">
              <div class="row mb-1">
                <div class="col-md-6">
                  <div class="d-flex align-items-center h-100">
                    <h5 class="mb-0 mt-2">List of Approved Requests</h5>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="d-flex float-end">
                    <div
                      id="tickets-table_filter"
                      class="dataTables_filter me-1"
                    >
                      <label class="d-inline-flex align-items-center">
                        <b-form-input
                          autocomplete="off"
                          v-model="filter"
                          type="search"
                          placeholder="Search Transaction..."
                          class="form-control"
                        ></b-form-input>
                      </label>
                    </div>
                    <div id="tickets-table_length" class="dataTables_length">
                      <label class="d-inline-flex align-items-center mb-0">
                        <b-form-select
                          class="form-select"
                          v-model="perPage"
                          size="sm"
                          :options="pageOptions"
                        >
                        </b-form-select>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="custom-table-responsive mb-0 mt-2">
                <b-table
                  class="propertyTable transactionTable datatables target-table"
                  :items="filtered"
                  :fields="postedFields"
                  responsive="sm"
                  :per-page="perPage"
                  :current-page="currentPage"
                  sort-by="id"
                  :sort-desc="true"
                  :busy="tableBusy"
                  show-empty
                  bordered
                >
                  <template #empty>
                    <b-card-header>
                      <div class="text-center">
                        <div v-if="filter != ''">
                          <i class="fas fa-exclamation-triangle me-2"></i>There
                          are no requests matching your request
                        </div>
                        <div v-else>
                          <i class="fas fa-exclamation-triangle me-2"></i>No
                          requests available
                        </div>
                      </div>
                    </b-card-header>
                  </template>
                  <template #table-busy>
                    <b-card-header>
                      <div
                        class="d-flex justify-content-center align-items-center"
                      >
                        <div class="preloader-component me-2">
                          <div class="status">
                            <div class="spinner-chase w-20px h-20px">
                              <div class="chase-dot"></div>
                              <div class="chase-dot"></div>
                              <div class="chase-dot"></div>
                              <div class="chase-dot"></div>
                              <div class="chase-dot"></div>
                              <div class="chase-dot"></div>
                            </div>
                          </div>
                        </div>
                        <strong>Loading...</strong>
                      </div>
                    </b-card-header>
                  </template>
                  <template #head(referenceNo)>
                    <div class="pb-4 text-center"><b>Transaction</b></div>
                  </template>
                  <template #cell(referenceNo)="row">
                    <div class="position-relative ms-1">
                      <RawData
                        :data="row.item"
                        v-if="$store.state.decrypt.isAdmin()"
                      />
                    </div>
                    <div class="p-3">
                      <small>{{
                        row.item.debit > 0
                          ? `PO No. ${row.item.referenceNumber}`
                          : `RIS No. ${row.item.referenceNumber}`
                      }}</small>
                      <div class="text-white" v-if="row.item.debit > 0">
                        {{ row.item.debit }} {{ row.item.stockItem.name }} added
                        to supply.
                      </div>
                      <div class="text-white" v-if="row.item.credit > 0">
                        {{ row.item.credit }}
                        {{ row.item.stockItem.name }} transferred to
                        {{ row.item.deliveryUnit.name }}.
                      </div>
                      <div>
                        <span class="me-1">Attachments:</span>
                        <a
                          href="javascript:void(0);"
                          @click="getAttachments(x)"
                          :id="`approved-viewFiles-${row.item.id}`"
                          >[Show attachments]</a
                        >
                        <b-popover
                          :target="`approved-viewFiles-${row.item.id}`"
                          triggers="click"
                          placement="right"
                          :show.sync="row.item.viewFile"
                          custom-class="popover-supplier"
                        >
                          <template v-slot:title>
                            <div
                              class="d-flex align-items-center justify-content-between"
                            >
                              <small>Attachments</small>
                              <span
                                class="bx bx-x font-size-14 cursor-pointer"
                                @click="row.item.viewFile = false"
                              ></span>
                            </div>
                          </template>
                          <table
                            class="table table-bordered"
                            v-if="
                              !row.item.attachmentLoading &&
                                row.item.stockFiles.length > 0
                            "
                          >
                            <thead>
                              <tr>
                                <th>File Description</th>
                                <th style="width: 30px"></th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr
                                v-for="attachments in row.item.stockFiles"
                                :key="attachments.id"
                              >
                                <td
                                  @click="openDocument(y)"
                                  class="hoverable-link cursor-pointer"
                                >
                                  <div>
                                    {{ attachments.description }}
                                  </div>
                                  <small>{{
                                    formatDateWithTime(
                                      new Date(attachments.dateTimeUploaded)
                                    )
                                  }}</small>
                                </td>
                                <td>
                                  <i
                                    v-if="
                                      isAdmin ||
                                        attachments.applicationUserId ==
                                          token.ApplicationUserId
                                    "
                                    @click="
                                      removeFile(attachments.id, row.item.id)
                                    "
                                    class="cursor-pointer bx bx-trash text-danger"
                                  ></i>
                                  <i v-else class="bx bx-trash text-muted"></i>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                          <div
                            class="text-center"
                            v-if="
                              !row.item.attachmentLoading &&
                                row.item.stockFiles.length == 0
                            "
                          >
                            No data found
                          </div>
                          <div
                            v-if="row.item.attachmentLoading"
                            class="text-center"
                          >
                            <b-spinner
                              variant="primary"
                              label="Loading..."
                            ></b-spinner>
                          </div>
                        </b-popover>
                      </div>
                      <div>
                        <button
                          :id="`approved-document${row.item.id}`"
                          type="button"
                          class="btn btn-sm btn-outline-success"
                          @click="row.item.addDocu = true"
                        >
                          <i class="bx bx-plus"></i>Add Attachments
                        </button>
                        <upload-popover
                          :option="uploadOptions"
                          :sourceId="row.item.id"
                          @uploaded="uploadedFiles"
                          :showPV="row.item.addDocu"
                          @closePopover="row.item.addDocu = false"
                          :dzId="`dropzone-approved${row.item.id}`"
                          :pvId="`approved-document${row.item.id}`"
                        ></upload-popover>
                      </div>
                    </div>
                  </template>
                  <template #head(description)>
                    <div class="pb-4 text-center"><b>Description</b></div>
                  </template>
                  <template #cell(description)="row">
                    <div class="p-3">
                      {{ row.item.description }}
                    </div>
                  </template>
                  <template #head(quantity)>
                    <div class="p-2 border-bottom text-center">
                      <b>Quantity</b>
                    </div>
                    <div class="p-0">
                      <div class="row m-0">
                        <div class="p-2 col-6 border-end text-center">
                          <b>Debit</b>
                        </div>
                        <div class="p-2 col-6 text-center">
                          <b>Credit</b>
                        </div>
                      </div>
                    </div>
                  </template>
                  <template #cell(quantity)="row">
                    <div class="row m-0">
                      <div
                        class="col-6 border-end d-flex align-items-center justify-content-center"
                        :class="{ 'text-success': row.item.debit }"
                      >
                        {{ row.item.debit > 0 ? row.item.debit : "-" }}
                      </div>
                      <div
                        class="col-6 d-flex align-items-center justify-content-center"
                        :class="{ 'text-danger': row.item.credit }"
                      >
                        {{ row.item.credit > 0 ? `- ${row.item.credit}` : "-" }}
                      </div>
                    </div>
                  </template>
                </b-table>
              </div>
              <div class="row">
                <div v-if="rows > 0" class="col">
                  Showing
                  {{ (currentPage - 1) * perPage + 1 }}
                  -
                  {{
                    rows > (currentPage - 1) * perPage + perPage
                      ? (currentPage - 1) * perPage + perPage
                      : rows
                  }}
                  of {{ rows }}
                </div>
                <div class="col">
                  <div
                    class="dataTables_paginate paging_simple_numbers float-end"
                  >
                    <ul
                      class="pagination pagination-rounded mb-0"
                      style="z-index: -1"
                    >
                      <!-- pagination -->
                      <b-pagination
                        v-model="currentPage"
                        :total-rows="rows"
                        :per-page="perPage"
                      ></b-pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-tab>
    </b-tabs>
    <Stocks ref="stocks" @dropData="dropDebit($event)"></Stocks>
    <Office ref="office" @dropData="dropOffice($event)"></Office>
    <print-options ref="printOpt"></print-options>
  </Layout>
</template>

<style>
.p-0 .popover-body {
  padding: 0 !important;
}
.propertyTable tr td {
  padding: 0 !important;
  margin: 0 !important;
}
.transactionTable tr th {
  padding: 0 !important;
  margin: 0 !important;
}
</style>
